import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Footer from "../../components/footer";
import Header from "../../components/header";
import AppTextField from "../../components/text-field/component";
import { Link } from "react-router-dom";
import AppButton from "../../components/button/component";
import Facebook from "../../assets/logo/facebook.svg";
import {
  getPortalCD,
  isAllAddressCookiePresent,
  getIPConfig,
  createCookie,
} from "../../utils/helpers";
import {
  CAREER_PREFERENCE_TEST_ASSESSMENT_ID,
  CAREER_TEST_ASSESSMENT_ID,
  ENNEAGRAM_TEST_ASSESSMENT_ID,
  FacebookAppId,
  generateContentKey,
  generateContentKeyForAssessment,
  getTenantId,
  removeWhitespace,
  ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
  wrapScoresWithTraitLevel,
} from "../../utils/general-config";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";
import PathHelper from "../../utils/path-helper";

import { toast } from "react-toastify";
import { validateEmail, validatePassword } from "../../utils/validation";
import { readCookie } from "../../utils/helpers";
import { useGoogleLogin } from "@react-oauth/google";
import GoogleLoginLogo from "../../assets/logo/google-normal.svg";
import { FacebookProvider, LoginButton } from "react-facebook";
import { trackEvents } from "../../utils/tracking-events";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Loader from "../../components/loader";
import {
  convertToLowerCase,
  getCookie,
  getCountryCode,
  InvitationStatus,
} from "../../utils/utility-functions";
import { traitType } from "../../services/enum/environment-enum";
import useSignOut from "../../utils/sign-out";
import { useDispatch } from "react-redux";
import FunnelStepTypes from "../funnel-step/types";

const PushGuestUserToFunnelStep = (guestUser) => {
  return {
    type: FunnelStepTypes.SET_GUEST_USER,
    guestUser,
  };
};

const Signup = ({
  createUserAccountConnect,
  funnelStep,
  createExternalUserAccountConnect,
  updateUserIdConnect,
  getContentLatestVersionConnect,
  getAssessmentResultByAssessmentAttemptIdConnect,
  createContentMapConnect,
  isGuestOrPremiumUserConnect,
  saveRelationshipCompatibilityResultConnect,
  saveUserAssessmentResultMapsConnect,
  createGuestUserWithoutEmailConnect,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const signOut = useSignOut();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const [modelType, setModelType] = useState("");
  const [userTraits, setUserTraits] = useState([]);
  const [resTraitType, setResTraitType] = useState();
  const [latestVersion, setLatestVersion] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFb, setIsLoadingFb] = useState(false);
  const [isLoadingG, setIsLoadingG] = useState(false);
  const [isParentUserGuestOrPremium, setIsParentUserGuestOrPremium] =
    useState(false);
  const token = getCookie("jwtToken");
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const localeForLink = locale ? `/${locale}` : "";
  const planPath = PathHelper(APP_NAVIGATION.PLAN, currentLocale);
  const dashboardPath = PathHelper(APP_NAVIGATION.DASHBOARD, currentLocale);
  const loginPath = PathHelper(APP_NAVIGATION.SINI, currentLocale);
  const parentIdFromQuery = queryParams.get("prntid");
  const assessmentMapIdFromQuery = queryParams.get("assessmapid");

  // const token = localStorage.getItem("jwtToken");
  const assessmentAttemptIdFromQuery =
    queryParams.get("assessmentAttemptId") || "";
  const paymentPageUrl = `${planPath.next}${
    assessmentAttemptIdFromQuery
      ? `?assessmentAttemptId=${assessmentAttemptIdFromQuery}`
      : ""
  }`;

  const {
    userGUID: oldUserId,
    assessmentAttemptId,
    assessmentId,
    countryCD: reduxCountryCD,
    currencyCD,
    isPremium,
  } = funnelStep || {};

  const countryCD = getCountryCode(reduxCountryCD);

  const isEnneagramAssessment =
    assessmentId.toLowerCase() === ENNEAGRAM_TEST_ASSESSMENT_ID.toLowerCase();
  const isCareerPreferenceAssesment =
    assessmentId.toLowerCase() ===
    CAREER_PREFERENCE_TEST_ASSESSMENT_ID.toLowerCase();

  const isCareerAssessment =
    assessmentId.toLowerCase() === CAREER_TEST_ASSESSMENT_ID.toLowerCase();

  const isRomanticCompatibilityTest =
    convertToLowerCase(assessmentId) ===
    convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState({
    emailError: "",
    passwordError: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isLoading]);
  const mappedUserTrait = useMemo(() => {
    return userTraits?.length > 0 ? wrapScoresWithTraitLevel(userTraits) : [];
  }, [userTraits]);

  const contentKey = useMemo(
    () => generateContentKey(mappedUserTrait),
    [mappedUserTrait]
  );

  useEffect(() => {
    if (!!assessmentAttemptId) {
      getAssessmentResultByAssessmentAttemptIdConnect(assessmentAttemptId).then(
        (res) => {
          if (!!res) {
            setUserTraits(res?.userTraits);
            setModelType(res?.modelType);
            setResTraitType(res?.traitType);
          }
        }
      );
    }
  }, [assessmentAttemptId]);

  useEffect(() => {
    if (!isCareerAssessment && modelType && contentKey) {
      const data = {
        modelType: modelType,
        contentKey:
          resTraitType === traitType.OPPOSITE
            ? contentKey
            : resTraitType === traitType.ONLYSUM &&
              (isEnneagramAssessment || isCareerPreferenceAssesment)
            ? generateContentKeyForAssessment(userTraits, assessmentId)
            : "ALL_CONTENT",
      };
      getContentLatestVersionConnect(data).then((res) => {
        if (res) {
          setLatestVersion(res);
        }
      });
    }
  }, [
    modelType,
    contentKey,
    isEnneagramAssessment,
    resTraitType,
    getContentLatestVersionConnect,
  ]);

  useEffect(() => {
    if (isRomanticCompatibilityTest && parentIdFromQuery) {
      setFormData({
        email: readCookie("email"),
      });
    }
  }, [isRomanticCompatibilityTest, parentIdFromQuery]);

  useEffect(() => {
    if (parentIdFromQuery && parentIdFromQuery !== null) {
      isGuestOrPremiumUserConnect(parentIdFromQuery).then((res) => {
        if (res) {
          setIsParentUserGuestOrPremium(res?.isPremiumOrGuestUser);
          createCookie(
            "romanticCompatibilityParentUserId",
            parentIdFromQuery,
            1
          );
        }
      });
    }
  }, [parentIdFromQuery]);

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (!!tokenResponse) {
        const userInfo = await axios
          .get(
            `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`,
            {
              headers: {
                Authorization: `Bearer ${tokenResponse.access_token}`,
              },
            }
          )
          .then((res) => {
            responseGoogle(res.data, tokenResponse.access_token);
          });
      } else {
        // setLoginError(true);
        // setLoginErrorMessage("Failed to login with google");
      }
    },
    onError: (errorResponse) => {
      // setLoginError(true);
      // setLoginErrorMessage("Failed to login with google");
      console.log(errorResponse);
    },
  });

  const contentMapData = {
    userGuid: oldUserId,
    contentKey: contentKey,
    modelType: removeWhitespace(modelType),
    assessmentAttemptId: assessmentAttemptId,
    version: latestVersion,
  };

  const handleRomanticCompatibilityResultSaving = ({ email, userGUID }) => {
    if (
      isRomanticCompatibilityTest &&
      parentIdFromQuery &&
      isParentUserGuestOrPremium
    ) {
      saveRelationshipCompatibilityResultConnect(assessmentMapIdFromQuery).then(
        (res) => {
          if (!!res) {
            const resultId = res.userTraits[0]?.userAssessmentResultId;
            const payloadAssessmentResultMap = [
              {
                userAssessmentResultId: resultId,
                sharedWithUserId: parentIdFromQuery,
              },
              {
                userAssessmentResultId: resultId,
                sharedWithUserId: userGUID,
              },
            ];
            saveUserAssessmentResultMapsConnect(
              payloadAssessmentResultMap
            ).then((res) => {
              const guestUserPayload = {
                id: oldUserId,
                firstName: readCookie("fName") || "",
                lastName: readCookie("lName") || "",
                emailAddress: email,
                invitationStatus: InvitationStatus.Accepted,
                parentId: parentIdFromQuery,
              };
              createGuestUserWithoutEmailConnect(guestUserPayload).then(
                (res) => {
                  if (!!res) {
                    dispatch(PushGuestUserToFunnelStep(true));
                  }
                }
              );
            });
          }
        }
      );
    }
  };

  const responseGoogle = (response, accessToken) => {
    if (!!response && !!accessToken) {
      const { name, email, id } = response;
      const externalData = {
        createUser: {
          countryCD: countryCD,
          currencyCD: currencyCD,
          portalCD: getPortalCD(),
          firstName: name,
          email: email,
          password: "",
          gender: localStorage.getItem("gender"),
          tenantId: getTenantId(),
          socialLogin: "google",
          locale: currentLocale,
          ...(isRomanticCompatibilityTest &&
            parentIdFromQuery &&
            isParentUserGuestOrPremium && {
              parentUserGuid: parentIdFromQuery,
            }),
        },
        externalLoginInfo: {
          loginType: 1,
          providerKey: id, // "100732998798818",
        },
      };
      setIsLoadingG(true);
      createExternalUserAccountConnect(externalData)
        .then((response) => {
          if (!!response) {
            const { isPremium } = response;
            setIsLoadingG(false);
            if (response.isValid) {
              const { userGuid } = response;
              const newUserGuid = userGuid;
              const oldUserGuid = oldUserId;
              const updateUserIdPayload = {
                oldUserGuid: oldUserGuid,
                newUserGuid: newUserGuid,
                assessmentId: assessmentId,
                assessmentAttemptId: assessmentAttemptId,
              };
              if (newUserGuid && oldUserGuid) {
                updateUserIdConnect(updateUserIdPayload).then((response) => {});
              }

              if (isPremium) {
                navigate(dashboardPath.next);
              } else {
                navigate(paymentPageUrl);
              }

              if (
                userGuid &&
                contentKey &&
                modelType &&
                assessmentAttemptIdFromQuery &&
                latestVersion
              ) {
                contentMapData.userGuid = userGuid;
                createContentMapConnect(contentMapData).then((res) => {});
              }
              handleRomanticCompatibilityResultSaving({
                email,
                userGUID: userGuid,
              });
            } else {
              toast.error(t("login.email_taken_msg"));
            }
          }
        })
        .catch((error) => {
          setIsLoading(false);
        })
        .finally(() => {
          setIsLoadingG(false); // Stop loader
        });
    }
  };

  useEffect(() => {
    if (!isAllAddressCookiePresent()) {
      getIPConfig(dispatch);
    }

    trackEvents("signUpView", {
      userGuid: oldUserId,
      eventLabel: "Page View",
      assessmentAttemptId: assessmentAttemptId,
      countryCD: countryCD,
      currencyCD: currencyCD,
      portalCD: getPortalCD(),
      visitId: readCookie("visitGuid"),
      visitorId: readCookie("visitorGuid"),
    });
  }, []);

  const responseFacebook = (response) => {
    if (response.status !== "unknown") {
      const { name, email, id, accessToken } = response.authResponse;
      const graphApiUrl = `https://graph.facebook.com/me?fields=email&access_token=${accessToken}`;
      fetch(graphApiUrl)
        .then((response) => response.json())
        .then((data) => {
          const { email, id } = data;
          const externalData = {
            createUser: {
              countryCD: countryCD,
              currencyCD: currencyCD,
              portalCD: getPortalCD(),
              firstName: name,
              gender: localStorage.getItem("gender"),
              email: email,
              password: "",
              tenantId: getTenantId(),
              socialLogin: "facebook",
              locale: currentLocale,
              ...(isRomanticCompatibilityTest &&
                parentIdFromQuery &&
                isParentUserGuestOrPremium && {
                  parentUserGuid: parentIdFromQuery,
                }),
            },
            externalLoginInfo: {
              loginType: 2, // Assuming 2 represents Facebook login
              providerKey: id, // Facebook User ID
            },
          };
          setIsLoadingFb(true);
          createExternalUserAccountConnect(externalData)
            .then((response) => {
              if (!!response) {
                const { isPremium } = response;

                if (response.isValid) {
                  const { userGuid } = response;
                  const newUserGuid = userGuid;
                  const oldUserGuid = oldUserId;
                  const updateUserIdPayload = {
                    oldUserGuid: oldUserGuid,
                    newUserGuid: newUserGuid,
                    assessmentId: assessmentId,
                    assessmentAttemptId: assessmentAttemptId,
                  };
                  if (oldUserGuid && newUserGuid) {
                    updateUserIdConnect(updateUserIdPayload).then(
                      (response) => {}
                    );
                  }

                  if (isPremium) {
                    navigate(dashboardPath.next);
                  } else {
                    navigate(paymentPageUrl);
                  }

                  if (
                    userGuid &&
                    contentKey &&
                    modelType &&
                    assessmentAttemptIdFromQuery &&
                    latestVersion
                  ) {
                    contentMapData.userGuid = userGuid;
                    createContentMapConnect(contentMapData).then((res) => {});
                  }
                  handleRomanticCompatibilityResultSaving({
                    email,
                    userGUID: userGuid,
                  });
                } else {
                  toast.error(t("login.email_taken_msg"));
                }
              }
            })
            .catch((error) => {
              console.error("Error during account creation: ", error);
            })
            .finally(() => {
              setIsLoadingFb(false); // Stop loader
            });

          // Use the email address here
        })
        .catch((error) => console.error("Error fetching email: ", error));
    } else {
      console.error("User did not authorize Facebook login.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    if (name === "email") {
      error = validateEmail(value, t);
    } else if (name === "password") {
      error = validatePassword(value, t);
    }
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    setError((prevError) => ({ ...prevError, [`${name}Error`]: error }));
  };

  useEffect(() => {
    if (token && isPremium) {
      navigate(dashboardPath.next);
    } else if (token && !isPremium) {
      navigate(planPath.next);
    } else if (!assessmentAttemptIdFromQuery) {
      signOut({ isNavigate: false });
    }
  }, [token, assessmentAttemptIdFromQuery, dashboardPath.next, isPremium]);

  const handleSignin = (event) => {
    event.preventDefault();
    const { email, password } = formData;
    const isEmailError = validateEmail(email.trim(), t);
    const isPwdError = validatePassword(password.trim(), t);
    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();
    if (isEmailError.length > 0) {
      setError((prevError) => ({ ...prevError, emailError: isEmailError }));
    } else {
      setError((prevError) => ({ ...prevError, emailError: "" }));
    }
    if (isPwdError.length > 0) {
      setError((prevError) => ({ ...prevError, passwordError: isPwdError }));
    } else {
      setError((prevError) => ({ ...prevError, passwordError: "" }));
    }
    if (isEmailError.length > 0 || isPwdError.length > 0) return;
    if (trimmedEmail.toLowerCase() === trimmedPassword.toLowerCase()) {
      toast.error(t("account.usernamePasswordSame"));
      return;
    }
    const params = {
      email: email.trim(),
      password: password.trim(),
      portalCD: getPortalCD(),
      tenantId: getTenantId(),
      countryCD: countryCD,
      currencyCD: currencyCD,
      existingUserId: oldUserId,
      gender: localStorage.getItem("gender"),
      locale: currentLocale,
      ...(isRomanticCompatibilityTest &&
        parentIdFromQuery &&
        isParentUserGuestOrPremium && {
          parentUserGuid: parentIdFromQuery,
        }),
    };

    setIsLoading(true);
    createUserAccountConnect(params, t)
      .then((response) => {
        if (response.isValid) {
          const { isPremium } = response;

          if (
            oldUserId &&
            contentKey &&
            modelType &&
            assessmentAttemptIdFromQuery &&
            latestVersion
          ) {
            createContentMapConnect(contentMapData).then((res) => {
              handleRomanticCompatibilityResultSaving({
                email: formData.email,
                userGUID: oldUserId,
              });
              if (isPremium) {
                navigate(dashboardPath.next);
              } else {
                navigate(paymentPageUrl);
              }
            });
          } else {
            if (isPremium) {
              navigate(dashboardPath.next);
            } else {
              navigate(paymentPageUrl);
            }
          }
        } else {
          toast.error(t("login.email_taken_msg"));
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Sign-in failed", error);
      })
      .finally(() => {
        setIsLoading(false); // Stop loader
      });
  };
  function handleError(error) {
    console.log(error);
  }
  const params = new URLSearchParams({
    assessmentAttemptId:
      assessmentAttemptIdFromQuery || assessmentAttemptId || "",
  });

  if (isRomanticCompatibilityTest && parentIdFromQuery) {
    params.set("prntid", parentIdFromQuery);
    if (assessmentMapIdFromQuery) {
      params.set("assessmapid", assessmentMapIdFromQuery);
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Loader isLoading={isLoading || isLoadingFb || isLoadingG} />
      <div className="flex-1 overflow-y-auto">
        <div className="p-5 text-center bg-white min-h-full flex flex-col justify-center items-center">
          <h1 className="text-[30px] lg:text-4xl font-bold font-montserrat text-center md:mb-4">
            <span className="text-[#444C5E]">
              {t("account.congrats_text")}
              <br className="md:hidden" />{" "}
            </span>
            <span className="text-purple-600"> {t("account.you_did_it")}</span>
          </h1>
          <p className="text-center mb-4 lg:mb-10 mt-3 font-semibold text-[16px] md:text-[20px] lg:text-[24px] text-[#444C5E]">
            {t("account.account_creation_prompt")}
          </p>
          <div className="flex flex-col gap-3">
            <FacebookProvider appId={FacebookAppId}>
              <LoginButton
                className="my-facebook-button-class"
                scope="email"
                onError={handleError}
                onSuccess={responseFacebook}
                cssClass="my-facebook-button-class"
                icon="fa-brands fa-facebook"
              >
                <div className="bg-white p-1 rounded-full">
                  <img src={Facebook} alt="" />
                </div>
                <span>{t("account.signup_facebook_cta")}</span>
              </LoginButton>
            </FacebookProvider>
            <button
              type="button"
              className="google-login-button"
              onClick={googleLogin}
            >
              <div>
                <img src={GoogleLoginLogo} alt="Google" />
              </div>
              <span> {t("account.signup_google_cta")}</span>
            </button>
          </div>
          <div className="flex items-center gap-2 mt-3">
            <div className="flex items-center gap-2">
              <div className="bg-gray-700 border border-gray-500 w-20 h-0.5"></div>
              <div className="text-black text-sm">{t("account.or_text")}</div>
              <div className="bg-gray-700 border border-gray-500 w-20 h-0.5"></div>
            </div>
          </div>
          <div className="w-full max-w-xs mt-4">
            <form className="space-y-4" onSubmit={handleSignin}>
              <AppTextField
                label={t("account.email_label")}
                name="email"
                onChange={handleInputChange}
                value={formData.email}
                error={error.emailError}
                placeholder={t("account.email_placholder")}
              />
              <AppTextField
                label={t("account.password_label")}
                name="password"
                onChange={handleInputChange}
                value={formData.password}
                error={error.passwordError}
                type="password"
                placeholder={t("account.password_placeholder")}
              />
              <div className="text-xs text-gray-500">
                <p>
                  {t("account.consent_confirmation_text")}
                  &nbsp;
                  <Link
                    to={`https://insightfultraits.com${localeForLink}/terms-conditions/`}
                    className="text-[#805AED] hover:underline"
                    target="_blank"
                  >
                    {t("account.term_of_use")}
                  </Link>{" "}
                  {t("account.and")}{" "}
                  <Link
                    to={`https://insightfultraits.com${localeForLink}/privacy-policy`}
                    className="text-[#805AED] hover:underline"
                    target="_blank"
                  >
                    {t("account.privacy_policy")}
                  </Link>
                  .
                </p>
              </div>
              <AppButton
                type="submit"
                className="bg-insightful-orange hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-insightful-orange text-white"
              >
                {t("account.create_account_cta")}
              </AppButton>
              <div className="text-center text-sm mt-4 mb-8">
                <p>
                  {t("account.already_account")} &nbsp;
                  <Link
                    to={`${loginPath.next}?${params.toString()}`}
                    className="text-[#805AED] hover:underline font-bold"
                    onClick={() => {
                      if (window.olark) {
                        window.olark("api.box.show");
                      }
                    }}
                  >
                    {t("account.member_login")}
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Signup;
